function LoadingFallback() {
    return (
        <div className="mx-auto my-auto font-bold text-xl">
            Loading...
        </div>
    )
}

export default LoadingFallback;